export const STORAGE_CAPACITY_EXCEEDED_ERROR = 'QuotaExceededError';
export const STORAGE_CAPACITY_EXCEEDED_FIREFOX_ERROR = 'NS_ERROR_DOM_QUOTA_REACHED';
export const LOCAL_STORAGE = 'localStorage';
//# sourceMappingURL=constants.js.map